import React, { useState } from "react";
import { IoMdClose } from "react-icons/io";

const HeaderPort = ({ hide, setHide }) => {
  const [active, setActive] = useState(1);
  return (
    <div
      className="row   "
      style={{ position: "sticky", top: "0", zIndex: "99999" }}
    >
      {hide ? (
        <div className="hidesidebar">
          <div className="closeicon " onClick={() => setHide(!hide)}>
            <IoMdClose style={{ fontSize: "30px" }} />
          </div>
          <div
            className={` ${active === 1 ? "main_nav2" : "main_nav"}  `}
            onClick={() => setActive(1)}
          >
            <a href="#Home">Home</a>
          </div>
          <div
            className={` ${active === 2 ? "main_nav2" : "main_nav"}  `}
            onClick={() => setActive(2)}
          >
            <a href="#Skills">Skills</a>
          </div>
          <div
            className={` ${active === 3 ? "main_nav2" : "main_nav"}  `}
            onClick={() => setActive(3)}
          >
            <a href="#About_me">About Me</a>
          </div>
          <div
            className={` ${active === 4 ? "main_nav2" : "main_nav"}  `}
            onClick={() => setActive(4)}
          >
            <a href="#Contact_me">Contact Me</a>
          </div>
          <div
            className={` ${active === 5 ? "main_nav2" : "main_nav"}  `}
            onClick={() => setActive(5)}
          >
            <a href="#Projects">Projects</a>
          </div>
          <div
            className={` ${active === 6 ? "main_nav2" : "main_nav"}  `}
            onClick={() => setActive(6)}
          >
            <a href="#Footer">Footer </a>
          </div>
        </div>
      ) : (
        <div className="hamburger">
          <div>
            <div onClick={() => setHide(!hide)} className="Hambbu"></div>
            <div onClick={() => setHide(!hide)} className="Hambbu"></div>
            <div onClick={() => setHide(!hide)} className="Hambbu"></div>
          </div>
        </div>
      )}
    </div>
  );
};

export default HeaderPort;
